import type { AcademySport } from '@court-sync/shared';
import { getAcademySportDisplayLabel } from '@/lib/sportPresentation';
import { Trophy } from 'lucide-react';

export interface SportFilterProps {
  value: string;
  onChange: (academySportId: string) => void;
  sports: AcademySport[];
  className?: string;
  ariaLabel?: string;
}

/** Compact sport picker for schedule and browse toolbars. */
export function SportFilter({
  value,
  onChange,
  sports,
  className = '',
  ariaLabel = 'Filter by sport',
}: SportFilterProps) {
  if (sports.length <= 1) return null;

  return (
    <div
      className={`relative flex w-full min-w-0 items-center sm:w-auto sm:max-w-[min(100%,15rem)] ${className}`}
    >
      <Trophy
        className="pointer-events-none absolute left-2.5 top-1/2 z-10 h-4 w-4 -translate-y-1/2 text-muted-foreground"
        aria-hidden
      />
      <select
        aria-label={ariaLabel}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="h-8 w-full min-w-0 truncate rounded-md border border-input bg-background py-1.5 pl-8 pr-2 text-sm shadow-sm focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring sm:max-w-[15rem]"
      >
        <option value="">All sports</option>
        {sports.map((sport) => (
          <option key={sport.id} value={sport.id}>
            {getAcademySportDisplayLabel(sport)}
          </option>
        ))}
      </select>
    </div>
  );
}
